const collectionProducts = document.querySelectorAll('#CollectionLoop > .product-item_product')

collectionProducts.forEach(product => {

    const swatchElements = product.querySelectorAll(".product__colors-swatch")
    
    swatchElements.forEach(swatch => {
        swatch.addEventListener('click', (e) => {
            updateVariant(e)
        })
    })
    
    const updateVariant = (e) => {
        const productElement = e.target.closest('.product-item_product');
        const productAtcBtn = productElement.querySelector('.product-item .quick-add__button') ? productElement.querySelector('.product-item .quick-add__button') : null;
    
        updateProductTitle(e, productElement);
        updateProductImages(e, productElement);
        if (productAtcBtn) {
            updateProductId(e, productElement, productAtcBtn);
            updateProductHandle(e, productElement, productAtcBtn);
        }
        updateProductUrl(e, productElement);
        updateProductPrice(e, productElement);
        updateBadges(e, productElement);
        updateStyleImages(e, productElement)
        updateActiveSwatch(e)
    }
    
    const updateProductTitle = (e, productElement) => {
        const productTitle = productElement.querySelector('.product-item__title');
        const variantTitle = e.target.closest('.product__colors-swatch').dataset.variantName
        productTitle.innerHTML = variantTitle 
    }
    
    const updateProductImages = (e, productElement) => {
        const productMainImgData = productElement.querySelector('.product-item .product-item__bg');
        const productHoverImgData = productElement.querySelector('.product-item .product-item__bg__under');

        const productMainImg = productElement.querySelector('.product-item .product-item__bg img');
        const productHoverImg = productElement.querySelector('.product-item .product-item__bg__under img');
    
        const swatch = e.target.closest('.product__colors-swatch')

        let variantMainImg
        let variantHoverImg

        const newProductImgSrc = swatch.dataset.productImage
        const newLifestyleImgSrc = swatch.dataset.lifestyleImage
    
        if (lifestyleStyle.classList.contains('hidden')) {
            variantMainImg = newProductImgSrc
            variantHoverImg = newLifestyleImgSrc
		} else {
            variantMainImg = newLifestyleImgSrc
            variantHoverImg = newProductImgSrc
		}

        productMainImgData.style.backgroundImage = `url("${variantMainImg}")`
        productHoverImgData.style.backgroundImage = `url("${variantHoverImg}")`
    
        productMainImg.src = variantMainImg
        productMainImg.srcset = variantMainImg

        productHoverImg.src = variantHoverImg
        productHoverImg.srcset = variantHoverImg
    }
    
    const updateProductId = (e, productElement, productAtcBtn) => {
        const variantId = e.target.closest('.product__colors-swatch').dataset.productId
    
        productAtcBtn.dataset.quickAddVariant = variantId
    }

    const updateProductHandle = (e, productElement, productAtcBtn) => {
        const variantHandle = e.target.closest('.product__colors-swatch').dataset.variantHandle
    
        productAtcBtn.dataset.variantHandle = variantHandle
    }
    
    const updateProductUrl = (e, productElement) => {
        const productLinks = productElement.querySelectorAll('.product-item .product-link');
        const variantUrl = e.target.closest('.product__colors-swatch').dataset.productUrl
    
        productLinks.forEach(link => {
            link.href = variantUrl
        })
    }

    const updateProductPrice = (e, productElement) => {
        const productPrice = productElement.querySelector('.product-item__price');
        const variantPrice = e.target.closest('.product__colors-swatch').dataset.variantPrice
        productPrice.innerHTML = `<span class="price"><span class="new-price">${variantPrice}</span></span>`
    }

    const updateBadges = (e, productElement) => {
        const productBadgesWrapper = productElement.querySelector('.product-item__image > .badge-boxes');
        const variantAvailable = e.target.closest('.product__colors-swatch').dataset.variantAvailable
        const productAtc = productElement.querySelector('quick-add-product');

        const soldContent = e.target.closest('.product__colors-swatch').dataset.soldOutContent
        const onSaleContent = e.target.closest('.product__colors-swatch').dataset.onSaleContent
        const preorderContent = e.target.closest('.product__colors-swatch').dataset.preorderContent
        const customBadgesArray = e.target.closest('.product__colors-swatch').dataset.customBadges.split(',')

        productBadgesWrapper.innerHTML = '';

        if (variantAvailable == 'false') {
            const soldBadge = document.createElement('div')

            soldBadge.classList.add('badge')
            soldBadge.textContent = soldContent

            productBadgesWrapper.appendChild(soldBadge)

            productAtc.style.display = 'none'
        }
         else {
            productAtc.style.display = 'block'

            if (onSaleContent) {
                const onSaleBadge = document.createElement('div')

                onSaleBadge.classList.add('sale-box')
                onSaleBadge.classList.add('badge')
                onSaleBadge.textContent = onSaleContent

                productBadgesWrapper.appendChild(onSaleBadge)
            }

            if (preorderContent) {
                const preorderBadge = document.createElement('div')

                preorderBadge.classList.add('preorder-box')
                preorderBadge.classList.add('badge')
                preorderBadge.textContent = preorderContent

                productBadgesWrapper.appendChild(preorderBadge)
            }

            if (customBadgesArray.length > 0) {
                for (let i = 0; i < customBadgesArray.length; i++) {
                    const customBadgeContent = customBadgesArray[i];
                    const customBadge = document.createElement('div')
            
                    customBadge.classList.add('badge-box')
                    customBadge.classList.add('badge')
                    customBadge.textContent = customBadgeContent
            
                    productBadgesWrapper.appendChild(customBadge)
                }
            }
        }
    }

    const updateStyleImages = (e, productElement) => {
        const mainImageWrapper = productElement.querySelector('.product-item__bg')
        const swatch = e.target.closest('.product__colors-swatch')

        const newProductImgSrc = swatch.dataset.productImage
        const newLifestyleImgSrc = swatch.dataset.lifestyleImage
        
        mainImageWrapper.dataset.productImage = newProductImgSrc
        mainImageWrapper.dataset.lifestyleImage = newLifestyleImgSrc
    }

    const updateActiveSwatch = (e) => {
        const activeSwatch = product.querySelector('.active-swatch')

        activeSwatch.classList.remove('active-swatch')
        
        e.target.classList.add('active-swatch')
    }
})
